<template>
  <div class="navigation">
    <!--
      DRAWER
      style="margin-top: 140px;max-height: calc(100% - 140px);"
      class="navigation_drawer transparent"
    -->
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      :class="drawer ? 'drawer-expanded' : 'drawer-close'"
      app
      v-if="getUserType()=='Admin'||getUserType()=='Counter'||getUserType()=='Counter_offline'|| getUserType()=='Booking_office'|| getUserType()=='CounterPrinter'">
      <!-- <offline v-if="getUserType()=='Counter'||getUserType()=='Counter_offline'" @detected-condition="handleConnectivityChange">
      </offline> -->
      <v-list
        dense
        class="white navigation__container--drawer"
      >
        <template
          v-if="getUserType() == 'Booking_office'"
        >
          <!--<v-list-tile
            @click="selected_item='booking_office_section';selected_subitem='18Accesos';$router.push({name: 'booking_office'})"
            :class="selected_item!='booking_office_section'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"

          >
            <v-list-tile-content>
              <v-list-tile-title class="navigation__container--item_text_container" >
                Accesos
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>-->

          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            name="booking_office_section"
            title="Accesos"
            color="#49ADFB"
          />

        </template>

        <template
          v-else-if="getUserType() == 'CounterPrinter'"
        >

          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            name="CounterPrinter_section"
            title="Accesos"
            color="#49ADFB"
          />

        </template>

        <template
          v-else-if="getUserType() == 'Counter'"
        >
          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            name="access_counter"
            title="Accesos"
            color="#49ADFB"
          />

        </template>

        <template v-else>

          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().dashboard)"
            name="dashboard"
            title="Dashboard"
            color="#1476FB"
          />


          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().rewards) && this.getCompany().id != 7"
            name="reward"
            title="Fidelización"
            color="#e33c76"
          />

          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().access)"
            name="access"
            title="Accesos"
            color="#49ADFB"
          />


          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().custom_forms)"
            name="form"
            title="Formularios"
            color="#1DB2EE"
          />


          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().offers)"
            name="offer"
            title="Ofertas"
            color="#F44336"
          />


          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            name="users"
            title="Usuarios"
            color="#8931FB"
          />

          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().locations)"
            name="location"
            title="Locaciones"
            color="#1FCA2F"
          />

          <!-- <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().personal_trainer)"
            name="classnav"
            title="Personal Trainer"
            color="#78a2c6"
          /> -->

          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().news)"
            name="news"
            title="Noticias"
            color="#8642cb"
          />

          <!-- <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().events)"
            name="events"
            title="Eventos"
            color="#17a277"
          /> -->

          <!-- <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().company_connections)"
            name="internalclientconnection"
            title="Conexión Clientes"
            color="#6d1ac4"
          /> -->

          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().client_information)"
            name="clientinformation"
            title="Información Cliente"
            color="#49ADFB"
          />

          <!-- <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().inside_request)"
            name="insiderequest"
            title="Trámites Internos"
            color="#24bcc3"
          /> -->
          <NavigationOption
            :selected_item.sync="selected_item"
            :selected_subitem.sync="selected_subitem"
            :items="items"
            v-if="this.itemVisible(this.getCompany().messages)"
            name="notifications"
            title="Notificaciones"
            color="#49ADFB"
          />
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      color="white"
      app
      fixed
      clipped-left
    >
      <div class="navigation__container--toolbar">
        <div class="navigation__toolbar_options--menu">
          <img
            @click="drawer = !drawer"
            src="../../assets/img/menu.svg"
            class="navigation__container--toggle"
          >
          <span
            class="title ml-3 mr-5 navigation__text--title"
          >
          <img
            v-if="this.getCompany().personalize.app_logo != '' && this.getCompany().personalize.app_logo != null && this.getCompany().personalize.app_logo != undefined "
            @click="drawer = !drawer"
            style="max-width: 188px"
            :src="this.getCompany().personalize.app_logo.url"
          >
          <img
            v-else
            @click="drawer = !drawer"
            style="max-width: 188px"
            src="../../assets/img/logo.png"
          >
        </span>
        </div>
        <div
          class="navigation__toolbar_options"
          v-if="getUserType() == 'Booking_office'">
          <v-hover>
            <div
              slot-scope="{ hover }"
              @click="selected_item='booking_office_section';selected_subitem='18Registro de usuarios';$router.push({name: 'booking_office'})"
              :class="selected_item!='booking_office_section'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'booking_office_section' ? '#49ADFB !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <access :colorx="selected_item==='booking_office_section'?'#FFFFFF':'#49ADFB'"></access>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='booking_office_section'?'#FFFFFF':'#49ADFB'}">
                  Accesos
                </p>
              </div>
            </div>
          </v-hover>
          <v-hover>
            <div
              slot-scope="{ hover }"
              @click="logout()"
              class="navigation__toolbar_options--item">
              <img src="../../assets/img/logout.svg">
            </div>
          </v-hover>
        </div>
        <div
          class="navigation__toolbar_options"
          v-else-if="getUserType() == 'CounterPrinter'">
          <v-hover>
            <div
              slot-scope="{ hover }"
              @click="selected_item='CounterPrinter_section';selected_subitem='18Registro de usuarios';$router.push({name: 'counter_printer'})"
              :class="selected_item!='CounterPrinter_section'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'CounterPrinter_section' ? '#49ADFB !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <access :colorx="selected_item==='CounterPrinter_section'?'#FFFFFF':'#49ADFB'"></access>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='CounterPrinter_section'?'#FFFFFF':'#49ADFB'}">
                  Accesos
                </p>
              </div>
            </div>
          </v-hover>
          <v-hover>
            <div
              slot-scope="{ hover }"
              @click="logout()"
              class="navigation__toolbar_options--item">
              <img src="../../assets/img/logout.svg">
            </div>
          </v-hover>
        </div>
        <div
          class="navigation__toolbar_options"
          v-else-if="getUserType() == 'Counter'">
          <v-hover>
            <div
              slot-scope="{ hover }"
              @click="selected_item='access_counter'"
              :class="selected_item!='booking_office_section'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'booking_office_section' ? '#49ADFB !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <access :colorx="selected_item==='booking_office_section'?'#FFFFFF':'#49ADFB'"></access>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='booking_office_section'?'#FFFFFF':'#49ADFB'}">
                  Accesos
                </p>
              </div>
            </div>
          </v-hover>
          <v-hover>
            <div
              slot-scope="{ hover }"
              @click="logout()"
              class="navigation__toolbar_options--item">
              <img src="../../assets/img/logout.svg">
            </div>
          </v-hover>
        </div>
        <div class="navigation__toolbar_options" v-else>
          <v-hover v-if="this.itemVisible(this.getCompany().access)">
            <div
              slot-scope="{ hover }"
              @click="selected_item='access';selected_subitem='8Resumen';$router.push({name: 'access'})"
              :class="selected_item!='access'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'access' ? '#49ADFB !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <access :colorx="selected_item==='access'?'#FFFFFF':'#49ADFB'"></access>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='access'?'#FFFFFF':'#5A6B8E'}">
                  Accesos
                </p>
              </div>
            </div>
          </v-hover>
          <v-hover v-if="this.itemVisible(this.getCompany().offers)">
            <div
              slot-scope="{ hover }"
              @click="selected_item='offer';selected_subitem='0Ofertas creadas';$router.push({name: 'offer'})"
              :class="selected_item!='offer'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'offer' ? '#F44336 !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <offer :colorx="selected_item==='offer'?'#FFFFFF':'#F44336'"></offer>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='offer'?'#FFFFFF':'#47474c'}">
                  Ofertas
                </p>
              </div>
            </div>
          </v-hover>
          <v-hover v-if="this.itemVisible(this.getCompany().locations)">
            <div
              slot-scope="{ hover }"
              @click="selected_item='location';selected_subitem='1Todos';$router.push({name: 'location'})"
              :class="selected_item!='location'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'location' ? '#1FCA2F !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <location :colorx="selected_item==='location'?'#FFFFFF':'#1FCA2F'"></location>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='location'?'#FFFFFF':'#5A6B8E'}">
                  Locaciones
                </p>
              </div>
            </div>
          </v-hover>
          <v-hover v-if="this.itemVisible(this.getCompany().news)">
            <div
              slot-scope="{ hover }"
              @click="selected_item='news';selected_subitem='9Todas';$router.push({name: 'news'})"
              :class="selected_item!='news'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'news' ? '#8642cb !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <news :colorx="selected_item==='news'?'#FFFFFF':'#8642cb'"></news>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='news'?'#FFFFFF':'#5A6B8E'}">
                  Noticias
                </p>
              </div>
            </div>
          </v-hover>
          <!-- <v-hover v-if="this.itemVisible(this.getCompany().company_connections)">
            <div
              slot-scope="{ hover }"
              @click="selected_item='internalclientconnection';selected_subitem='internalclientconnection';$router.push({name: 'segments'})"
              :class="selected_item!='internalclientconnection'?'navigation__toolbar_options--item':'navigation__toolbar_options--item_selected'"
              :style="{backgroundColor: selected_item === 'internalclientconnection' ? '#6d1ac4 !important' : ''}"
            >
              <div class="navigation__toolbar_options--container">
                <internalclientconnection :colorx="selected_item==='internalclientconnection'?'#FFFFFF':'#6d1ac4'"></internalclientconnection>
                <p
                  class="navigation__toolbar_options--text"
                  :style="{'color': selected_item==='internalclientconnection'?'#FFFFFF':'#5A6B8E'}"
                >
                  Empresas
                </p>
              </div>
            </div>
          </v-hover> -->
        </div>
        <v-hover>
          <v-toolbar-items>
            <v-menu>
              <template v-slot:activator="{ on }">
                <div
                  class="toolbar_dropdown"
                  v-on="on"
                >
                  <v-flex>
                    <div>
                      Hola, <span class="toolbar_dropdown--title">
                      {{ getNameUser() }}
                    </span>
                    </div>
                    <label class="toolbar_dropdown--email">
                      {{ getEmailUser() }}
                    </label>
                  </v-flex>
                  <img src="../../assets/img/arrow-down.svg" class="toolbar_dropdown--icon">
                </div>
              </template>
              <v-list>
                <v-list-tile @click="logout()">
                  <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar-items>
        </v-hover>
      </div>
    </v-toolbar>
  </div>
</template>

<script>
import user from './navigation/User'
import offline from 'v-offline';
import NavigationOption from './OptionNavigationDrawer.vue'
import invitations_services from "../../services/invitations_services";

export default {
  data: () => ({
    drawer: true,
    selected_item: '',
    selected_subitem: '',
    current_name: 'Dashboard',
    charged: false,
    // current_name:'Accesos',
    items: [],
  }),
  props: {},
  watch: {
    selected_item: function () {
      if (this.selected_item === 'offer') {
        this.current_name = 'Ofertas';
      } else if (this.selected_item === 'reward') {
        this.current_name = 'Rewards';
      } else if (this.selected_item === 'access') {
        this.current_name = 'Acceso';
      } else if (this.selected_item === 'users') {
        this.current_name = 'Usuarios';
      } else if (this.selected_item === 'location') {
        this.current_name = 'Locaciones';
      }
        // else if(this.selected_item==='classnav'){
        //   this.current_name='Personal Trainer';
      // }
      else if (this.selected_item === 'news') {
        this.current_name = 'Noticias';
      }
        // else if(this.selected_item==='events'){
        //   this.current_name='Eventos';
        // }
        // else if(this.selected_item==='internalclientconnection'){
        //   this.current_name='Conexión Clientes Internos';
      // }
      else if (this.selected_item === 'clientinformation') {
        this.current_name = 'Información Del Cliente';
      } else if (this.selected_item === 'insiderequest') {
        this.current_name = 'Trámites Internos';
      } else if (this.selected_item === 'form') {
        this.current_name = 'Formularioss';
      }
        // else if(this.selected_item==='insiderequest'){
        //   this.current_name='Trámites Internos';
        // }
        // else if(this.selected_item==='offline_counter_section'){
        //   this.current_name='Offline Counter Menú';
        // }else if(this.selected_item==='access_counter'){
        //   this.current_name='Counter'
      // }
      else {
        this.current_name = 'Dashboard';
      }
    }
  },
  beforeMount() {
    if (this.getUserType() === 'Admin') {
      // this.selected_item='dashboard';
      //this.selected_subitem='10Usuarios';
      this.selected_item = 'access';
    } else if (this.getUserType() === 'Counter') {
      this.selected_item = 'access_counter';
      this.selected_subitem = '16Resumen locación';
    } else if (this.getUserType() === 'Counter_offline') {
      this.selected_item = 'offline_counter_section';
      this.selected_subitem = '16Listado';
    } else if (this.getUserType() === 'Booking_office') {
      this.selected_item = 'booking_office_section';
      //this.selected_subitem='18Accesos'
      this.selected_subitem = '18Registro de usuarios';
    } else if (this.getUserType() == 'CounterPrinter') {
      this.selected_item = 'CounterPrinter_section';
      //this.selected_subitem='18Accesos'
      this.selected_subitem = '19Imprimir Ticket';
    } else {
      this.selected_subitem = '10Usuarios';
    }
    this.items = [
      {
        title: '',
        divider: true,
        principal_route: '',
        section: 'access',
        id: 8,
        visible: this.itemVisible(this.getCompany().access),
        links: [
          ///access/dashboard
          {
            icon: 'dashboard',
            text: 'Dashboard',
            route: 'dashboard_accesses',
            visible: this.getCompany().access.user_access
          },
          {icon: 'dashboard', text: 'Resumen', route: 'access', visible: this.getCompany().access.user_access},
          {
            icon: 'accessibility_new',
            text: 'Counter',
            route: 'counter_index',
            visible: this.getCompany().access.counter
          },
          {icon: 'article', text: 'Reportes', route: 'reports', visible: this.getCompany().access.reports},
          {
            icon: 'phonelink_ring',
            text: 'Accesos por dia',
            route: 'alerts_index',
            visible: this.getCompany().access.alerts
          },
          {
            icon: 'phonelink_ring',
            text: 'Multiples dispositivos',
            route: 'alerts_device_index',
            visible: this.getCompany().access.alerts
          },
          {
            icon: 'phonelink_ring',
            text: 'Vigilante Virtual - QR',
            route: 'virtual_guard_qr_generator',
            visible: this.getCompany().access.virtual_guard
          }
        ]
      },
      {
        title: 'Noticias',
        divider: true,
        principal_route: '',
        section: 'news',
        id: 9,
        visible: this.getCompany().news.general_news,
        links: [
          {icon: 'notifications', text: 'Todas', route: 'news', visible: this.getCompany().news.general_news},
          {icon: 'notifications', text: 'Públicas', route: 'news_public', visible: this.getCompany().news.general_news},
          {icon: 'notifications', text: 'Ocultas', route: 'news_hidden', visible: this.getCompany().news.general_news}
        ]
      },
      {
        title: 'Videos',
        divider: true,
        principal_route: '',
        section: 'news',
        id: 10,
        visible: this.getCompany().news.video_news,
        links: [
          {icon: 'list', text: 'Videos', route: 'news_video', visible: this.getCompany().news.video_news}
        ]
      },
      {
        title: 'Titulares',
        divider: true,
        principal_route: '',
        section: 'news',
        id: 9,
        visible: this.getCompany().news.twits_news,
        links: [
          {icon: 'list', text: 'Titulares', route: 'news_headline', visible: this.getCompany().news.twits_news},
        ]
      },
      {
        title: 'Categorías',
        divider: true,
        principal_route: '',
        section: 'news',
        id: 11,
        visible: this.itemVisible(this.getCompany().news),
        links: [
          {icon: 'list', text: 'Categorías', route: 'special_categories', visible: this.getCompany().news.general_news}
        ]
      },
      // aqui se deben separar las rutas
      {
        title: 'Dashboard',
        divider: false,
        principal_route: '',
        section: 'dashboard',
        id: 12,
        visible: this.itemVisible(this.getCompany().dashboard),
        links: [
          {icon: 'account_box', text: 'Usuarios', route: 'users_charts', visible: this.getCompany().dashboard.users},
          {
            icon: 'local_activity',
            text: 'Ofertas',
            route: 'offers_charts',
            visible: this.getCompany().dashboard.offers
          },
          {icon: 'place', text: 'Locaciones', route: 'locations_charts', visible: this.getCompany().dashboard.access},
          {
            icon: 'notifications_active',
            text: 'Rewards',
            route: 'rewards_charts',
            visible: this.getCompany().dashboard.rewards
          },
        ]
      },
      {
        title: 'Usuarios ',
        divider: false,
        principal_route: '',
        section: 'users',
        id: 13,
        visible: true,
        links: [
          {icon: 'list', text: 'Todos', route: 'users', visible: true},
          {icon: 'mood', text: 'Activos', route: 'users_active', visible: true},
          {icon: 'mood_bad', text: 'Inactivos', route: 'users_inactive', visible: true},
          {icon: 'date_range', text: 'Generar Reserva', route: 'booking_index', visible: true},
          {icon: 'app_blocking', text: 'Cancelar Reserva', route: 'cancel_booking', visible: true},
          {icon: 'edit', text: 'Editar Información', route: 'edit_user', visible: true},
          {icon: 'layers', text: 'Importar Usuarios', route: 'import_users', visible: true},
          {icon: 'layers', text: 'Importar Empleados', route: 'import_employees', visible: true},
          {icon: 'list', text: 'Planes de usuario', route: 'user_list_plans', visible: true},
          {icon: 'layers', text: 'Crear plan de usuario', route: 'user_create_plan', visible: true},
          {icon: 'travel_explore', text: 'Geolocalizaciones', route: 'users_geolocations', visible: false},
          {icon: 'print', text: 'Imprimir Qr', route: 'generate_qr', visible: true},
          {icon: 'list', text: 'Medios de acceso', route: 'access_devices', visible: true},
          {icon: 'list', text: 'Reestablecer dispositivos', route: 'reset_user_devices', visible: true},
          {
            icon: 'list',
            text: 'Configurar Inmueble',
            route: 'configure_property',
            visible: this.getCompany().payments.admin_payments
          },
          {
            icon: 'list',
            text: 'Métodos de pago',
            route: 'payment_methods',
            visible: this.getCompany().payments.admin_payments
          }
        ]
      },
      {
        title: 'Características',
        divider: false,
        principal_route: '',
        section: 'reward',
        id: 14,
        visible: this.itemVisible(this.getCompany().rewards),
        links: [
          {
            icon: 'list',
            text: 'Características',
            route: 'segments',
            visible: this.getCompany().rewards.user_characteristics
          },
        ]
      },
      {
        title: 'Counter',
        divider: true,
        principal_route: '',
        section: 'access_counter',
        id: 15,
        visible: this.getCompany().access.counter,
        links: []
      },
      {
        title: 'Usuarios',
        divider: true,
        principal_route: '',
        section: 'access_counter',
        id: 16,
        visible: this.getCompany().access.counter,
        links: [
          {icon: 'dashboard', text: 'Resumen locación', route: 'access_counter', visible: true},
          {icon: 'edit', text: 'Editar Información', route: 'edit_user', visible: true},
          {icon: 'date_range', text: 'Generar Reserva', route: 'booking_index', visible: true},
          {icon: 'app_blocking', text: 'Cancelar Reserva', route: 'cancel_booking', visible: true},
          {icon: 'print', text: 'Imprimir Qr', route: 'generate_qr', visible: true}
        ]
      },
      {
        title: 'Usuarios',
        divider: true,
        principal_route: '',
        section: 'offline_counter_section',
        id: 17,
        visible: true,
        links: [
          {icon: 'dashboard', text: 'Listado', route: 'offline_users', visible: true,},
          {icon: 'vpn_key', text: 'Pin  usuario', route: 'offline_counter', visible: true,},
        ]
      },
      {
        title: 'Accesos',
        divider: true,
        principal_route: '',
        section: 'booking_office_section',
        id: 18,
        visible: true,
        links: [
          {icon: 'app_registration', text: 'Registro de usuarios', route: 'booking_office', visible: true}
        ]
      },
      {
        title: 'Accesos',
        divider: true,
        principal_route: '',
        section: 'CounterPrinter_section',
        id: 19,
        visible: true,
        links: [{icon: 'app_registration', text: 'Imprimir Ticket', route: 'counter_printer', visible: true}]

      },
      {
        title: 'Información Cliente',
        divider: true,
        principal_route: '',
        section: 'clientinformation',
        id: 20,
        visible: this.getCompany().client_information.us,
        links: [
          {icon: '', text: 'Acerca de nosotros', route: 'about_us', visible: this.getCompany().client_information.us},
        ]
      },
      {
        title: 'Trámites Internos',
        divider: true,
        principal_route: '',
        section: 'insiderequest',
        id: 21,
        visible: true,
        links: [
          {icon: '', text: 'Listado', route: 'notification', visible: true},
        ]
      },
      {
        title: 'Formularios',
        divider: true,
        principal_route: '',
        section: 'form',
        id: 22,
        visible: this.getCompany().forms.custom_forms,
        links: [
          {icon: '', text: 'Listado', route: 'forms_index', visible: this.getCompany().forms.custom_forms},

        ],
      },
      {
        title: 'Notificaciones',
        divider: true,
        principal_route: '',
        section: 'notifications',
        id: 23,
        visible: this.itemVisible(this.getCompany().messages),
        links: [
          {
            icon: 'notifications',
            text: 'Notificaciones',
            route: 'notification',
            visible: this.getCompany().notifications.push_notifications
          },
          {
            icon: 'notifications',
            text: 'Emails',
            route: 'email_historial',
            visible: this.getCompany().messages.segment_mails
          }
        ],
      },
    ]
  },
  components: {
    user: user,
    offline,
    NavigationOption
  },
  methods: {

    logout() {
      this.stopInvitationChecker();
      console.log('*******logout******')
      if (!window.eel) {
        window.location = '/';
      } else {
        window.eel.close_program()
        window.close();
        window.location = '/';
      }
    },

    changeRoute(item, link) {
      ///NO se usa este metodo ir a OPTIONNAVIGATIONDRAWER
      this.selected_subitem = item.id + link.text;
      if (link.current_section != null &&
        link.current_section != undefined &&
        link.current_section != '') {
        this.updateDashboardActive(link.current_section)
      }
      if (this.selected_subitem == '14Inicio') {
        this.$router.push({
          name: 'location_access',
          params: {
            id: localStorage.getItem('location_id'),
            filter: false,
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            namex: localStorage.getItem('location_name')
          }
        })
      } else if (this.selected_subitem == "14Resumen locación") {
        this.$router.push({
          name: 'access_counter',
          params: {
            id: localStorage.getItem('location_id'),
            filter: false,
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            namex: localStorage.getItem('location_name')
          }
        })
      } else if (this.selected_subitem == "15Generar Reserva") {
        this.$router.push({
          name: 'booking_index',
          params: {id: localStorage.getItem('location_id'), location_name: localStorage.getItem('location_name')}
        })
      } else {
        this.$router.push({name: item.principal_route != '' ? item.principal_route + '_' + link.route : link.route})
      }
    },
    handleConnectivityChange(status) {
      this.logout()
      let val = "Se ha desconectado de internet, por favor vuelva a ingresar para entrar al modo Offline"
      if (status) {
        val = "Se ha conectado de nuevo a internet, por favor vuelva a ingresar"
      }
      if (navigator.userAgent == "Comfamiliar-Gimnasios-Desktop-App") {
        this.updateAlertMessage(val)
        this.updateIsInAlert(true)
      } else {
        alert(val)
      }
    },
    itemVisible(company_object) {
      return Object.entries(company_object).filter(([key, value]) => value !== "" && value === true).length > 0
    },
    subscribeToApprovalInvitationsChannel() {
      this.$cable.subscribe({
        channel: "ApprovalInvitationsChannel",
        room: `room_approval_invitations_${this.getUserId()}`,
        approval_user_id: this.getUserId()
      });
    },
  },
  channels: {
    ApprovalInvitationsChannel: {
      connected() {
        console.log("Connected to approval invitations channel!");
      },
      received(data) {
        if (!data.id) return;
        invitations_services.getInvitations({
          id: this.getUserId(),
          status: this.getUserIsApprover() ? "approved" :"active",
          invitation_state: "ACTIVE"
        }).then(response => {
          this.loadInvitations(response);
        })

      },
      disconnected() {
        console.log("Disconnected of events mon channel!");
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.subscribeToApprovalInvitationsChannel();
    }, 800);
  }

}
</script>
<style>
.drawer-expanded {
  min-width: 18.75% !important;
  margin-left: 4.1% !important;
  background: rgb(247, 247, 249) !important;
}

.drawer-close {
  min-width: 18.75% !important;
  margin-left: 0% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Navigation.vue